export var version = "1.9.4";
//# sourceMappingURL=version.js.map